module.exports = __webpack_public_path__ + "img/loading.8497a9b8.svg";